import toolkitService from '../../services/ToolkitService';

// One long read run ON THE SERVER (toolkit jobs.js, a READ job) — for the reads that can take longer than API
// Gateway's 29 seconds: a property's blocks and their grids, every reservation of a market code, OXI mapping
// validation. Called with the same area / op / args as the screen's direct call would use; resolves with the same
// result that call's `data.result` would hold, or throws with the op's own error.
//
// The lambda keeps working after the gateway gives up, so asked directly these answered with a 504 while the result
// was still being built — and the screen never saw it. Here the read is started, watched until it is done, and its
// result (which can be many megabytes) is fetched from the file the job wrote.
//
// onStatus(text) is told how it is going, for the screen's step message.

const POLL_MS = 2000;
const ACTIVE = new Set(['STARTING', 'RUNNING']);
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
const errorOf = (e) => e?.response?.data?.error?.message || e?.response?.data?.message || e?.message || 'Request failed';

const serverRead = async (ctx, { area, op, args = {}, screen, title, onStatus = () => {} }) => {
    let job;
    try {
        ({ job } = (await toolkitService.jobs(ctx, 'start', { kind: 'READ', screen, title, item: { area, op, args } })).data);
    } catch (e) {
        throw new Error(errorOf(e));
    }
    const started = Date.now();
    onStatus('Running on the server…');
    while (ACTIVE.has(job.status)) {
        await sleep(POLL_MS);
        job = (await toolkitService.jobs(ctx, 'get', { jobId: job.id })).data.job;
        onStatus(`Running on the server… ${Math.round((Date.now() - started) / 1000)}s`);
    }
    const { data } = await toolkitService.jobs(ctx, 'result', { jobId: job.id, i: 0 });
    if (data.status === 'failed' || job.status === 'FAILED') throw new Error(data.errorMessage || job.error || 'The read failed on the server');
    if (!data.url) return data.result;
    const res = await fetch(data.url);
    if (!res.ok) throw new Error(`Could not fetch the result (${res.status})`);
    return res.json();
};

export default serverRead;
